import { Attendance } from "@/@types/esus/Attendance";
import { AttendanceProcedureReqEval } from "@/@types/esus/AttendanceProcedureReqEval";
import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizensAttendancesIndicatorC4Params = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	isEvaluated?: boolean;
	export?: boolean;
};

export class DetailedCitizenAttendancesIndicatorC4Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	lastAttendanceStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	lastBloodPressureMeasurementStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	lastWeightAndHeightMetricsRegisterStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	lastGlycatedHemoglobinStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	lastFootAssessmentStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	attendances?: Attendance[];
	lastAttendance?: Attendance;
	bloodPressureMeasurements?: Attendance[];
	footAssessmentAttendanceProceduresReqEval?: AttendanceProcedureReqEval[];
	glycatedHemoglobinAttendanceProceduresReqEval?: AttendanceProcedureReqEval[];
	weightAndHeightMetricsRegisters?: Attendance[];
}

export async function getDetailedCitizensAttendancesIndicatorC4({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAttendancesIndicatorC4Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAttendancesIndicatorC4Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c4/detailed-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAttendancesIndicatorC4Data>();
}
